import React from 'react';
import {render, unmountComponentAtNode} from '@inlet/react-pixi';
import {IReactView} from '@gongxigames/framework/core/fragments/react/IReactView';
import {ReactMediator} from '@gongxigames/framework/core/fragments/react/ReactMediator';
import {Container} from 'pixi.js';

export function renderReactView(view: IReactView): ReactMediator {
    return render(React.createElement(ReactMediator, {view}), view.container);
}

export function unmountComponent(container: Container): void {
    unmountComponentAtNode(container);
}
